// Necesario para compilar por Webpack
import 'regenerator-runtime/runtime';

/**
 * Componentes LIT
 * */
import BuscadorAreasWebs from './componentes/BuscadorAreasWebs.js';

customElements.define('iv-buscador-areas-webs', BuscadorAreasWebs);
